import { useEffect, useState } from "react";

import { CustomNotification } from "../../../../../util/CustomNotification";
import * as customerClientService from "../../../../../services/customerClientService";
import useValue from "../../../../../hooks/useValue";

import type { CustomerClientKeyFobStats } from "../../../../../shared/interface/customerClient.interface";

const useCustomerClientKeyFobStats = (props: { customerClientId: number | null }) => {
  /* CONSTANTS */

  /* STATE */
  const [customerClientKeyFobStats, setCustomerClientKeyFobStats] = useState<CustomerClientKeyFobStats | null>(null);

  /* CUSTOM HOOK */
  const { value: loading, handleValue: handleLoading } = useValue(true);

  /* HANDLERS */

  /* EFFECTS */
  useEffect(() => {
    const fetchCustomerClientKeyFobStats = async () => {
      try {
        if (!props.customerClientId) return;
        handleLoading(true);

        const res = await customerClientService.getCustomerClientKeyFobStats(props.customerClientId);

        setCustomerClientKeyFobStats(res?.data);
      } catch (error) {
        CustomNotification.showErrorMessage(error);
      } finally {
        handleLoading(false);
      }
    };

    fetchCustomerClientKeyFobStats();
  }, [props.customerClientId]);

  return { loading, customerClientKeyFobStats };
};

export default useCustomerClientKeyFobStats;
